import React from 'react';
import './rating.scss';

const Rating = (props) => (
    <small>
        <span className="star-rating-s15"/>
        <span className="total-rating-out-five">{props.ratingFive}</span>
        {props.totalCount && <span className="total-rating">({props.totalCount})</span>}
    </small>
);

export default Rating;



// WEBPACK FOOTER //
// ./src/reviews/rating/rating.js